import GooglePlacesSearchDropdown from "@/components/maps/location-search";
import OpenInMapsDrawer from "@/components/drawers/open-in-maps-drawer";
import { Button, Card, Label, useOverlayState } from "@heroui/react";
import { Map, MapPin, Send } from "lucide-react";

const MeetingDetailsLocationComp = ({ value, onChange }) => {
  const currentAddress = value?.location?.name;
  const { lat, lng } = value?.location ?? {};
  const mapsState = useOverlayState();

  const staticMapUrl =
    lat != null && lng != null
      ? `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=15&size=600x300&scale=2&markers=color:0x5855A0%7C${lat},${lng}&key=${import.meta.env.VITE_GOOGLE_MAPS_API_KEY}`
      : null;

  function handleSelect(place) {
    onChange({
      location: {
        name: place["name"],
        place_id: place["place_id"],
        lat: place["lat"],
        lng: place["lng"],
      },
    });
  }

  return (
    <Card className="bg-[#FFFFFFAD] dark:bg-[#000000B2]">
      <Card.Content className="gap-7">
        <div className="flex flex-col gap-1.5">
          <Label className={"flex items-center gap-1"}>
            <MapPin size={12} className="" /> Event Location
          </Label>

          <GooglePlacesSearchDropdown
            defaultValue={currentAddress}
            placeholder="Type an address or place"
            inputClassName={"border-r-0 shadow-none h-9 bg-background! border-y-muted/20 dark:border-[#ECECEC26] border-y-1 border-r-0"}
            onSelect={handleSelect}
          />

          <div className="mt-4 flex flex-col gap-2">
            <Label className={"flex items-center gap-1"}>
              <Map size={12} />
              Map Preview
            </Label>
            {staticMapUrl ? (
              <div className="relative">
                <img
                  src={staticMapUrl}
                  alt={currentAddress || "Selected location"}
                  className="w-full h-40 rounded-xl object-cover"
                />

                <Button className={"absolute bottom-2 left-2 bg-white text-accent"} size="sm" onPress={mapsState.open}>
                  <Send /> Open in Maps
                </Button>
              </div>
            ) : (
              <div className="h-40 rounded-xl bg-surface-secondary flex items-center justify-center text-xs text-muted">
                No location selected yet
              </div>
            )}
          </div>
        </div>
      </Card.Content>

      <OpenInMapsDrawer location={value?.location} state={mapsState} />
    </Card>
  );
};

export default MeetingDetailsLocationComp;